// Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

function Footer() {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <footer style={{
      backgroundColor: isDark ? '#1A1A1A' : '#f1f1f1',
      padding: '1rem 2rem',
      textAlign: 'center',
      color: isDark ? '#8B95A3' : '#777777',
      fontSize: '0.9rem',
      transition: 'background-color 0.3s ease, color 0.3s ease',
    }}>
      <p>© 2025 AI人事. All rights reserved.</p>
      <div style={{
        marginTop: '0.5rem',
        display: 'flex',
        justifyContent: 'center',
        gap: '1rem',
      }}>
        <Link to="/terms" style={{
          textDecoration: 'none',
          color: theme.palette.primary.main,
          transition: 'color 0.2s',
        }}>利用規約</Link>
        <Link to="/privacy" style={{
          textDecoration: 'none',
          color: theme.palette.primary.main,
          transition: 'color 0.2s',
        }}>プライバシーポリシー</Link>
      </div>
    </footer>
  );
}

export default Footer;
